import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import ja from "date-fns/locale/ja";
import TextField, { type TextFieldProps } from "@mui/material/TextField";

type DatePickerJapaneseProps = {
  label?: string;
  value?: Date | null;
  onChange?: (value: Date | null, column?: string) => void;
  column?: string;
  inputFormat?: string;
  placeholder?: string;
  format?: string;
  type?: "date" | "datetime";
};

const DatePickerJapanese = ({
  label,
  value,
  onChange,
  column,
  inputFormat,
  placeholder,
  format,
  type = "date",
}: DatePickerJapaneseProps) => {
  const handleChangeCalender = (e: Date | null) => {
    if (onChange && typeof onChange === "function") {
      onChange(e === null ? null : e, column);
    }
  };

  const commonProps = {
    label,
    value,
    inputFormat:
      inputFormat || (type === "datetime" ? "yyyy-MM-dd HH:mm" : undefined),
    format: format,
    mask: type === "datetime" ? "____年__月__日 __:__" : "____年__月__日",
    toolbarFormat: "yyyy年MM月dd日",
    onChange: handleChangeCalender,
    slotProps: {
      toolbar: {
        toolbarFormat: "yyyy/MM/dd",
      },
      textField: { size: "small" as const },
    },
  };

  if (type === "datetime") {
    return (
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={ja}
        dateFormats={{ monthAndYear: "yyyy/MM" }}
        localeText={{
          previousMonth: "前月を表示",
          nextMonth: "次月を表示",
          cancelButtonLabel: "キャンセル",
          okButtonLabel: "選択",
          datePickerToolbarTitle: "日付選択",
        }}
      >
        <DateTimePicker
          {...commonProps}
          slotProps={{
            ...commonProps.slotProps,
            field: { clearable: true },
          }}
          textFieldProps={(params: TextFieldProps) => (
            <TextField
              defaultValue={null}
              size="small"
              {...params}
              inputProps={{
                inputMode: "numeric",
                ...params.inputProps,
                placeholder: placeholder || "****年**月**日",
              }}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ja}
      dateFormats={{ monthAndYear: "yyyy/MM" }}
      localeText={{
        previousMonth: "前月を表示",
        nextMonth: "次月を表示",
        cancelButtonLabel: "キャンセル",
        okButtonLabel: "選択",
        datePickerToolbarTitle: "日付選択",
      }}
    >
      <DesktopDatePicker
        {...commonProps}
        slotProps={{
          ...commonProps.slotProps,
          field: { clearable: true },
          inputProps: {
            inputMode: "numeric",
            placeholder: placeholder || "yyyy年MM月dd日",
          },
        }}
      />
    </LocalizationProvider>
  );
};
export default DatePickerJapanese;
